<div class="background">

    <app-header></app-header>
    <app-navbar *ngIf="!isMobile"></app-navbar>
    <section>
        <app-main-table-domiciliacion  *ngIf="showMain"  (changeTableEvent)="changeTable($event)"></app-main-table-domiciliacion>
        <app-month-table-domiciliacion *ngIf="!showMain" (changeTableEvent)="changeTable($event)"></app-month-table-domiciliacion>
    </section>
</div>
